import { useTranslation } from "react-i18next";

export const SelectionAreasLegend = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-2 flex flex-col gap-1.5">
      <div className="flex items-start gap-2 text-sm text-gray-700">
        <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-red-600" />
        <span>
          <span className="font-semibold">
            {t("smartSurveyor.selectionAreas.modeExclude")}
          </span>
          {" — "}
          {t("smartSurveyor.selectionAreas.legendExclude")}
        </span>
      </div>
      <div className="flex items-start gap-2 text-sm text-gray-700">
        <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-emerald-600" />
        <span>
          <span className="font-semibold">
            {t("smartSurveyor.selectionAreas.modeInclude")}
          </span>
          {" — "}
          {t("smartSurveyor.selectionAreas.legendInclude")}
        </span>
      </div>
      <p className="text-xs text-gray-500">
        {t("smartSurveyor.selectionAreas.legendFootnote")}
      </p>
    </div>
  );
};
